import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button'

const AuthButton = () => {
  return (
    <div className="flex space-x-8 justify-center mt-10">
      <div className="flex flex-col items-center space-y-2 w-48">
        <Link to="/login" className="w-full">
          <Button className="w-full h-14 text-lg">Existing User</Button>
        </Link>
        <p className="text-sm text-muted-foreground text-center">
         Note: Already have an account? Login here.
        </p>
      </div>
      <div className="flex flex-col items-center space-y-2 w-48">
        <Link to="/register" className="w-full">
          <Button variant="outline" className="w-full h-14 text-lg">New User</Button>
        </Link>
        <p className="text-sm text-muted-foreground text-center">
         Note: Don’t have an account yet? Register now.
        </p>
      </div>
    </div>
  )
}

export default AuthButton
